import React from 'react'
import CircularProgress from '@material-ui/core/CircularProgress'

import { useRef, useScroll } from 'src/hooks'

import * as drawerStyles from '../styles/components/Drawer.module.scss'
import styles from '../styles/components/images.module.scss'
import CloseButton from 'src/chrome/CloseButton/CloseButton'
import { Div } from '@sendoutcards/quantum-design-ui'

interface ImageBase {
  smallThumb: string
  id: string
}

type Props<T extends ImageBase> = {
  result: T[]
  isLoading: boolean
  hasMore: boolean
  loadMore: () => void
  onSelect?: (image: T) => void
  deleteImage?: (id: string) => void
  deleting?: string
}

const Images = <T extends ImageBase>(
  props: React.PropsWithChildren<Props<T>>,
) => {
  const {
    isLoading,
    hasMore,
    loadMore,
    onSelect,
    deleteImage,
    result,
    deleting,
  } = props

  const triggerElement = useRef<HTMLDivElement>(null)

  const handleScroll = useScroll({
    isLoadingMore: isLoading,
    hasMore,
    loadMore,
    triggerElement,
  })

  return (
    <div className={drawerStyles.images} onScroll={handleScroll}>
      {result.map((image, index) => {
        const backgroundImage = {
          backgroundImage: `url(${image.smallThumb})`,
        }

        const isDeleting = deleting === image.id

        return (
          <div className={styles.imageAsset} key={index}>
            {deleteImage && !isDeleting && (
              <Div className={styles.deleteButton}>
                <CloseButton size={22} onClose={() => deleteImage(image.id)} />
              </Div>
            )}
            {onSelect && (
              <div
                id={`select_photo_${index}`}
                className={styles.backgroundImage}
                style={backgroundImage}
                onClick={() => {
                  onSelect(image)
                }}
              >
                {isDeleting && (
                  <div style={{ display: 'flex' }}>
                    <CircularProgress />
                  </div>
                )}
              </div>
            )}
          </div>
        )
      })}
      {hasMore && (
        <div
          ref={triggerElement}
          style={{
            background: 'transparent',
            boxShadow: 'none',
            width: '60px',
            height: '60px',
          }}
        >
          <CircularProgress />
        </div>
      )}
    </div>
  )
}

export default Images
